export enum FROM_PAGE_MANAGEMENT {
  FILE_MANAGEMENT = "fileManagement",
  PIPELINE_MANAGEMENT = "pipelineManagement",
  CLASSIFICATION_PIPELINE_MANAGEMENT = "classificationPipelineManagement",
  WORKFLOW_MANAGEMENT = "workflowManagement",
}
